module.exports = __webpack_public_path__ + "static/media/patientEducationImage.71e4c74e.svg";